<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="cs_wrapper" >
  <div *ngIf="!isShared" class="row">
    <div class="col-lg-12 mt-1 mb-2">
      <!--<div class="float-right d-none d-lg-block">
        <a href="javascript:void(0)" (click)="onCopyLink()" class="btn btn-sm btn-primary ml-2"> Shareable Link </a>
      </div>-->
    </div>
  </div>
  <table>
    <thead>
      <tr>
        <td>
          <div class="cs_header">
            <div class="cs_list">
              <div class="cs_list-item">
                <span class="cs_hl">Email:</span> {{analysis.publicUserEmail}}
              </div>
              <div class="cs_list-item">
                <span class="cs_hl">Date:</span> {{analysis.dateTime | date:'short' }}
              </div>
            </div>
            <a href="https://rundna.com/" target="_blank"> <img class="cs_logo" src="../../../../assets/img/runningreport/logo.png" alt="logo" /></a>
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <!-- page 1 -->
          <div class="card card-body">
            <div class="cs_panel">
              <div class="cs_sec-header">
                <div class="cs_sec overal">
                  <div>
                    <h1>2D Running Report</h1>
                  </div>
                </div>
              </div>

              <div *ngIf="analysis.status == assessmentAiStatus.Completed || analysis.status == assessmentAiStatus.Failed" class="cs_sec-header">
                <div class="video-tabs">
                  <button class="video-tab" (click)="showSideVideo()">
                    <i class="fas fa-play"></i> Side Video
                  </button>
                  <button class="video-tab" (click)="showBackVideo()">
                    <i class="fas fa-play"></i> Back Video
                  </button>
                </div>
              </div>

              <div *ngIf="analysis.status == assessmentAiStatus.Completed" class="cs_notes cs_mt1">
                <div class="cs_notes-label">Score: {{analysis.score | number: '1.1-1'}}%</div>
                <div class="cs_notes-content stretch-text">
                 Category: {{ impairmentCategoryEnum[analysis.impairmentCategory]}}; Cue: {{ runningCueEnum[analysis.runningCue]}}
                </div>
              </div>

              <div *ngIf="analysis.status != assessmentAiStatus.Completed && analysis.status != assessmentAiStatus.Failed" class="cs_stats-wrapper cs_gap cs_mt2">
                <div class="center-flex status-card">

                  <div class="processing-message">
                    <!--<div class="loader-spinner"></div>-->
                    <span>
                      Your RunDNA 2D Assessment is <b>processing</b>.
                      This may take a few minutes, depending on the number of assessments in the queue.
                    </span>
                  </div>

                  <div class="cnn-image-progress-wrap">
                    <div class="progress-bar-over-image">
                      <div class="progress-bar-wrap">
                        <div class="progress-bar"></div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <div *ngIf="analysis.status == assessmentAiStatus.Completed || analysis.status == assessmentAiStatus.Failed" class="cs_stats-wrapper cs_gap cs_mt2">
                <img src="../../../../assets/img/runningreport/human.png" alt="image" class="cs_image_001" />

                <!--  -->
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <h3>
                      General Form
                    </h3>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_stats-col-label text-underline">Left</div>
                    <div class="cs_score s-{{ analysis.generalForm.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.generalForm.left | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_stats-col-label text-underline">Right</div>
                    <div class="cs_score s-{{ analysis.generalForm.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.generalForm.right | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                </div>
                <!--  -->
                <div class="cs_separator"></div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <h3>Pelvis</h3>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.pelvis.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.pelvis.left | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.pelvis.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.pelvis.right | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                </div>
                <!--  -->
                <div class="cs_separator"></div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <h3>Hips</h3>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.hip.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.hip.left | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.hip.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.hip.right | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                </div>
                <!--  -->
                <div class="cs_separator"></div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <h3>Knees</h3>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.knee.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.knee.left | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.knee.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.knee.right | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                </div>
                <!--  -->
                <div class="cs_separator"></div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <h3>Ankle</h3>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.ankles.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.ankles.left | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score s-{{ analysis.ankles.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.ankles.right | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col"></div>
                </div>
              </div>
            </div>

            <div *ngIf="analysis.status == assessmentAiStatus.Completed || analysis.status == assessmentAiStatus.Failed" class="cs_panel cs_mt1">
              <h3 style="color: gray; text-align: center; margin-bottom: 1em">GENERAL PARAMETERS</h3>
              <div class="cs_stats-wrapper cs_gap-sm ">

                <div class="cs_stats-row cs_around">
                  <div class="cs_stats-col cs_inline">
                    <h4>Cadence</h4>
                    <span>{{analysis.cadence.value | number:'1.0-0'}} spm</span>
                    <div class="cs_score sm s-{{ analysis.cadence.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.cadence.score | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4></h4>
                    <span></span>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4>Vertical Oscillation</h4>
                    <span>{{analysis.verticalOscillation.value  | number:'1.0-0'}} cm</span>
                    <div class="cs_score sm s-{{ analysis.verticalOscillation.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.verticalOscillation.score | enumString: categoryScoreEnum)}}</div>
                  </div>
                </div>

                <div class="cs_stats-row cs_around">
                  <div class="cs_stats-col cs_inline">
                    <h4></h4>
                    <span></span>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4>Vertical Oscillation Normalized</h4>
                    <span>{{analysis.verticalOscillationNormalized.value * 100  | number:'1.1-1'}}%</span>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4></h4>
                    <span></span>
                  </div>
                </div>
                <div class="cs_separator"></div>

                <div class="cs_stats-row cs_around">
                  <div class="cs_stats-col cs_inline">
                    <h4>Speed</h4>
                    <span>{{analysis.speed | number:'1.2-2' }} {{analysis.speedUnit | enumString: speedUnitEnum}}</span>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4>Calculated Speed</h4>
                    <span>{{analysis.calculatedSpeedInMs * 2.2369 | number:'1.2-2' }} {{analysis.speedUnit | enumString: speedUnitEnum}}</span>
                  </div>
                  <div class="cs_stats-col cs_inline">
                    <h4>Pelvis Minimal Speed</h4>
                    <span>{{analysis.calculatedMinPsisSpeedInMs * 2.2369 | number:'1.2-2' }} {{analysis.speedUnit | enumString: speedUnitEnum}}</span>
                  </div>
                </div>


                <div class="cs_separator"></div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center text-underline">Left</div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center text-underline">Right</div>
                  <div class="cs_stats-col"></div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.groundContactTime.leftValue| number:'1.0-0'}} ms</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.groundContactTime.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.groundContactTime.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Ground Contact Time</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.groundContactTime.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.groundContactTime.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.groundContactTime.rightValue| number:'1.0-0'}} ms</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.dutyFactor.leftValue| number:'1.0-0'}}%</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.dutyFactor.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.dutyFactor.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Duty Factor</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.dutyFactor.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.dutyFactor.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.dutyFactor.rightValue| number:'1.0-0'}}%</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.frontSideStance.leftValue| number:'1.0-0'}}%</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.frontSideStance.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.frontSideStance.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Front Side Stance</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.frontSideStance.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.frontSideStance.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.frontSideStance.rightValue| number:'1.0-0'}}%</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.stiffness.leftValue / 1000 | number:'1.2-2'}} kN/m</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.stiffness.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.stiffness.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Stiffness</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.stiffness.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.stiffness.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.stiffness.rightValue / 1000| number:'1.2-2'}} kN/m</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.strideLength.leftValue| number:'1.0-0'}} cm</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.strideLength.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.strideLength.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Stride Length</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.strideLength.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.strideLength.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.strideLength.rightValue| number:'1.0-0'}} cm</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.scom.leftValue)| number:'1.0-0'}} cm</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.scom.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.scom.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>SCOM</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.scom.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.scom.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.scom.rightValue)| number:'1.0-0'}} cm</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.icTibialInclination.leftValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.leftValue)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.icTibialInclination.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Tibial Inclination</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.icTibialInclination.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.icTibialInclination.rightValue)| number:'1.0-0'}}° {{getLabelTibialInclination(analysis.icTibialInclination.rightValue)}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakCPD.leftValue)| number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.leftValue, true)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakCPD.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Contralateral Pelvic Drop</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakCPD.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakCPD.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakCPD.rightValue)| number:'1.0-0'}}° {{getLabelPelvicDrop(analysis.peakCPD.rightValue, false)}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakHipAdduction.leftValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.leftValue)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Hip Adduction</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipAdduction.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakHipAdduction.rightValue)| number:'1.0-0'}}° {{getLabelHipAdduction(analysis.peakHipAdduction.rightValue)}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakHipFlexion.leftValue)| number:'1.0-0'}}° flex</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipFlexion.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipFlexion.leftScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Hip Flexion</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipFlexion.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipFlexion.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakHipFlexion.rightValue)| number:'1.0-0'}}° flex</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.forwardLean.value)| number:'1.0-0'}}° {{getLabelForwardLean(analysis.forwardLean.value)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.forwardLean.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.forwardLean.score | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Forward Lean</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.forwardLean.score | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.forwardLean.score | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.forwardLean.value)| number:'1.0-0'}}° {{getLabelForwardLean(analysis.forwardLean.value)}}</div>
                </div>

                <hr class="cs_page-break" />
                <div class="cs_separator"></div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center text-underline">Left</div>
                  <div class="cs_stats-col"></div>
                  <div class="cs_stats-col to-center text-underline">Right</div>
                  <div class="cs_stats-col"></div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{analysis.footStrikeLeft | enumString: footStrikePatternEnum}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-u">U</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Foot Strike</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-u">U</div>
                  </div>
                  <div class="cs_stats-col">{{analysis.footStrikeRight| enumString: footStrikePatternEnum}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.icFootInclination.leftValue)| number:'1.0-0'}}° {{getLabelFootInclination(analysis.icFootInclination.leftValue)}} </div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.icFootInclination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.icFootInclination.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Foot Inclination</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.icFootInclination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.icFootInclination.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.icFootInclination.rightValue)| number:'1.0-0'}}° {{getLabelFootInclination(analysis.icFootInclination.rightValue)}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.crossover.leftValue)| number:'1.0-0'}} cm {{getLabeCrossover(analysis.crossover.leftValue)}} </div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.crossover.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.crossover.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Crossover</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.crossover.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.crossover.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.crossover.rightValue)| number:'1.0-0'}} cm {{getLabeCrossover(analysis.crossover.rightValue)}}</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakKneeFlexion.leftValue)| number:'1.0-0'}}° flex</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakKneeFlexion.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakKneeFlexion.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Knee Flexion</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakKneeFlexion.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakKneeFlexion.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakKneeFlexion.rightValue)| number:'1.0-0'}}° flex</div>
                </div>
                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakAnklePronation.leftValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.peakAnklePronation.leftValue)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakAnklePronation.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnklePronation.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Ankle Pronation</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakAnklePronation.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnklePronation.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakAnklePronation.rightValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.peakAnklePronation.rightValue)}}</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakAnkleDorsiflexion.leftValue)| number:'1.0-0'}}° DF</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakAnkleDorsiflexion.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnkleDorsiflexion.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Ankle Dorsiflexion</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakAnkleDorsiflexion.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakAnkleDorsiflexion.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakAnkleDorsiflexion.rightValue)| number:'1.0-0'}}° DF</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.peakHipExtension.leftValue)| number:'1.0-0'}}° ext</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipExtension.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipExtension.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Peak Hip Extension</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.peakHipExtension.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.peakHipExtension.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.peakHipExtension.rightValue)| number:'1.0-0'}}° ext</div>
                </div>

                <div class="cs_stats-row">
                  <div class="cs_stats-col">
                    <div class="cs_stats-value">{{removeNegtiveSign(analysis.tsAnkleSupination.leftValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.tsAnkleSupination.leftValue)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.tsAnkleSupination.leftScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.tsAnkleSupination.leftScore  | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col to-center">
                    <h4>Ankle Supination TS</h4>
                  </div>
                  <div class="cs_stats-col to-center">
                    <div class="cs_score sm s-{{ analysis.tsAnkleSupination.rightScore | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.tsAnkleSupination.rightScore | enumString: categoryScoreEnum)}}</div>
                  </div>
                  <div class="cs_stats-col">{{removeNegtiveSign(analysis.tsAnkleSupination.rightValue)| number:'1.0-0'}}° {{getLabelAnklePronatoin(analysis.tsAnkleSupination.rightValue)}}</div>
                </div>
              </div>
            </div>
            <div  *ngIf="analysis.status == assessmentAiStatus.Completed|| analysis.status == assessmentAiStatus.Failed" class="cs_notes cs_mt1" >
              <div *ngIf="analysis.assessmentNotes" class="cs_notes-label">Notes:</div>
              <div *ngIf="analysis.assessmentNotes" class="cs_notes-content" title="{{analysis.assessmentNotes}}">
                {{ (analysis.assessmentNotes.length>330) ? (analysis.assessmentNotes | slice:0:330) + '...' : (analysis.assessmentNotes) }}
              </div>
            </div>

            <div *ngIf="analysis.status == assessmentAiStatus.Completed|| analysis.status == assessmentAiStatus.Failed" class="cs_score-tab cs_mt1 score_descr">
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Good
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-g">g</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Fair
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-f">f</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label">
                  Poor
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-p">p</div>
                </div>
              </div>
              <div class="cs_score-tab-item">
                <div class="cs_score-tab-item-label" style="margin-left: -1.5em">
                  Coming Soon
                </div>
                <div class="cs_score-tab-item-review">
                  <div class="cs_score  s-u">u</div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
